import React from 'react'
import {
    Form,
    Label,
    Input,
    Button,
    Col,
    Row,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    Container,
} from 'reactstrap'
import { Redirect, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import { isEmpty } from 'lodash'
import {
    updateRecipient,
    updateResponse,
    getStateProvinces,
    resendEmailService,
    updateResponseResendEmail,
    getRecipient,
    sendToRouter,
    updateRouter,
} from '../../api/giftApi'
import CustomDatePicker from '../CustomDatePicker'
import PopupError from '../PopupError'
import CardTitle from '../CardTitle'
import FormValidator from '../FormValidation'
import { formatEditDate, formatDateFields, formatDateFieldsLocalized, formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers'
import { updateRedirect } from '../../helpers/redirect'
import { RefundByGift, RefundChargeByGift, updateRefund } from '../../api/clubapi'
import { getSettings } from '../../api/userapi'
import '../css/EditCreate.css'
import '../css/OverlayLoader.css'
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';
import MakeAComment from '../MakeAComment'
import { getCurrentUser } from '../../api/userapi'
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'


class GiftEdit extends React.Component {
    constructor(props) {
        super(props)
        this.props.route.history.push('/secure/gifts')
        this.props.route.history.push(this.props.route.match.url)
        this.userInfo = getCurrentUser();
        this.validator = new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'email',
                method: this.isEmail,
                validWhen: false,
                message: 'Value is not a valid email format',
            },
            {
                field: 'deliveryDate',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'deliveryDate',
                method: this.isAfter,
                validWhen: true,
                message: 'Value may neither be in the past nor more than 90 days in the future',
            },
            {
                field: 'deliveryDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Value may neither be in the past nor more than 90 days in the future',
            },
            // {
            //     field: 'expirationDate',
            //     method: 'isEmpty',
            //     validWhen: false,
            //     message: 'Value is required'
            // },
        ])
        this.enrollmentValidator = new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'email',
                method: this.isEmail,
                validWhen: false,
                message: 'Value is not a valid email format',
            },
            {
                field: 'telephone',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'telephone',
                method: this.isTelephone,
                validWhen: false,
                message: 'Must be valid phone number.',
            },
            {
                field: 'streetAddress',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'city',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'stateProvince',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'postalCode',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
            {
                field: 'birthYear',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.',
            },
        ])
        const recipient = null
        this.state = {
            loading: false,
            readOnly: true,
            recipient,
            cancel: false,
            saved: false,
            error: false,
            comment: '',
            commentAuthor: '',
            commentDate: '',
            edit: false,
            errorMessage: [],
            validation: this.validator.valid(),
            enrollmentValidation: this.enrollmentValidator.valid(),
            baseState: '',
            stateProvinces: [],
            originalDelivery: '',
            _deliveryDate: '',
            _expirationDate: '',
            deliveryDateChanged: false,
            viewChargeUrl: '',
            toggle: false,
            toggleEnroll: false,
            redirectProduct: false,
            redirectSales: false,
            disableSendClub: false,
        }
        this.closeModal = this.closeModal.bind(this)
        this.onProductLink = this.onProductLink.bind(this)
        this.onSaleLink = this.onSaleLink.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.toggleModalEnroll = this.toggleModalEnroll.bind(this)
        this.handleRefund = this.handleRefund.bind(this)
        this.showCharge = this.showCharge.bind(this)
        this.handleResendEmail = this.handleResendEmail.bind(this)
        this.sendRouter = this.sendRouter.bind(this)
    }

    isBefore = state => this.addDaysCurrent(90)

    isAfter = state => this.currentDay()

    isEmail = state =>
        !state.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )

    isTelephone = state => !state.match(/^\D?(\d{3,5})\D?\D?(\d{3,5})\D?(\d{4,5})$/)

    toggleModal() {
        this.setState(prevState => ({
            toggle: !prevState.toggle,
        }))
    }

    toggleModalEnroll() {
        this.setState(prevState => ({
            toggleEnroll: !prevState.toggleEnroll,
        }))
    }

    showCharge() {
        let vcurl = this.state.viewChargeUrl
        vcurl = vcurl.replace('{0}', this.state.recipient.stripeAccountId)
        vcurl = vcurl.replace('{1}', this.state.recipient.stripeChargeId)
        window.open(vcurl, '_blank')
    }

    handleRefund(event) {
        event.preventDefault();

        if (parseInt(this.amount.value) > parseInt(this.state.recipient.totalCharge)) {
            alert('Amount to refund cannot be greater than charged one')
        } else {
            this.setState({ loading: true })
            this.toggleModal()
            this.props.RefundChargeByGift(
                this.state.recipient.clubId,
                this.state.recipient.recipientId
            )
            this.props.getRecipient(
                (result, _this) => {
                    _this.getDataRecipient(result, _this)
                },
                this,
                this.state.recipient.recipientId
            )
        }
    }

    // Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit(e) {
        e.preventDefault();
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true,
        }))
    }

    onChangeComment = (e) => {
        this.isInvalid(e)
        const d = new Date();
        let x = this.state.recipient
        x.comment = e.target.value
        x.commentAuthor = this.userInfo.data.firstName + ' ' + this.userInfo.data.lastName;
        x.commentDate = d;
        this.setState({ recipient: x, comment: e.target.value })
    }

    closeModal() {
        this.setState({ error: false })
        this.submitted = false
    }

    componentDidMount() {
        this.props.getSettings(function (result, _this) {
            _this.getSettingsData(result, _this)
        }, this)
        const recipientId = this.props.route.match.params.id
        this.props.getRecipient(
            function (result, _this) {
                _this.getDataRecipient(result, _this)
            },
            this,
            recipientId
        )
        this.props.getStateProvinces(function (result, _this) {
            _this.getDataStates(result, _this)
        }, this)
    }

    getSettingsData(value, _this) {
        _this.setState({
            viewChargeUrl: value.data.value.viewChargeUrl,
        })
    }

    // Shows options of array of state names. Saves stateProvinceId in "id" attribute so we can save StateProvinceId state in form.
    renderStateProvinces() {
        return this.state.stateProvinces.map((stateProvince, index) => {
            return (
                <option id={stateProvince.stateProvinceId} key={index}>
                    {stateProvince.state}
                </option>
            )
        })
    }

    getDataStates(data, _this) {
        _this.setState({
            stateProvinces: data.data.data,
            loading: false,
        })
    }

    onProductLink() {
        this.props.currentNavigationConnect({
            isOpen: false,
            selected: 'products',
            selectedAdmin: '',
            toggleAdminDropdown: false,
        })
        this.setState({ redirectProduct: true })
    }

    onSaleLink() {
        this.props.currentNavigationConnect({
            isOpen: false,
            selected: 'sales',
            selectedAdmin: '',
            toggleAdminDropdown: false,
        })
        this.setState({ redirectSales: true })
    }

    handleResendEmail() {
        this.setState({ loading: true })
        this.props.resendEmailServiceConnect(
            function (result, _this) {
                _this.getDataRecipient(result, _this)
            },
            this,
            this.state.recipient.recipientId
        )
    }

    handleResendEnrollment = () => {
        this.setState({
            loading: true,
            disableSendClub: true
        });

        // Llamamos a sendRouter
        this.props.sendToRouter(this.state.recipient.enrollment.enrollmentId);

        // Abrimos el modal
        this.setState({
            toggleEnroll: true,
            loading: false
        });
    }

    sendRouter() {
        this.setState({
            loading: true,
            disableSendClub: true,
        })
        this.props.sendToRouter(this.state.recipient.enrollment.enrollmentId)
        this.setState({
            loading: false
        })

    }

    // Redirects to club list
    handleCancel = () => {
        if (this.state.edit) {
            this.setState(state => ({
                readOnly: !state.readOnly,
                recipient: JSON.parse(state.baseState),
                comment: JSON.parse(state.baseState).comment,
                edit: false,
                // sets validation to previous state
                validation: this.validator.valid(),
                enrollmentValidation: this.enrollmentValidator.valid(),
            }))
            this.submitted = false
            // Removes the is-invalid class from all inputs when editing is canceled
            const els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }
        } else {
            this.setState({
                cancel: true,
            })
        }
    }

    addDays(date, days) {
        if (date) {
            const result = new Date(date)
            const newDate = new Date(result.setDate(result.getDate() + days))
                .toISOString()
                .substring(0, 10)
            return newDate
        }
        return date
    }

    addDaysCurrent(days) {
        if ((formatDateFields(`${this.state.recipient.deliveryDate}T00:00:00`) !== this.state._deliveryDate)
            && this.state.deliveryDateChanged) {
            const d = new Date()
            const result = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
            const newDate = new Date(result.setDate(result.getDate() + days))
                .toISOString()
                .substring(0, 10)
            return this.state.recipient.deliveryDate <= newDate
        }
        return true
    }

    currentDay() {
        if ((formatDateFields(`${this.state.recipient.deliveryDate}T00:00:00`) !== this.state._deliveryDate)
            && this.state.deliveryDateChanged) {
            const d = new Date()
            const result = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
            const newDate = new Date(result).toISOString().substring(0, 10)
            return this.state.recipient.deliveryDate >= newDate
        }
        return true
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.forceUpdate) {
            this.setState({ forceUpdate: false })
            this.handleSubmit()
        }


        if (this.props.responseRefund !== prevProps.responseRefund) {
            const resultRefund = this.props.responseRefund
            if (resultRefund) {
                if (resultRefund.data.success) {
                    // Aqu� agregamos la recarga del recipient
                    this.props.getRecipient(
                        (result, _this) => {
                            _this.getDataRecipient(result, _this);
                            _this.setState({ forceUpdate: true });
                        },
                        this,
                        this.state.recipient.recipientId
                    )
                } else if (resultRefund.data.success === false) {
                    const errorList = []
                    resultRefund.data.errors.map(function (e) {
                        errorList.push(e.message)
                    })
                    this.setState({ loading: false, error: true, errorMessage: errorList })
                }
            }
        }

        if (this.props.updateResult !== prevProps.updateResult) {
            const result = this.props.updateResult
            // Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    const x = JSON.stringify(cloneDeep(this.state.recipient), function (key, value) {
                        if (value === null) {
                            return ''
                        }
                        return value
                    })
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        validation: this.validator.valid(),
                        readOnly: true,
                        _expirationDate: !state.recipient.expirationDate
                            ? ''
                            : formatInTimeZoneDate(`${state.recipient.expirationDate}T00:00:00`, state.recipient.branchIanaTimeZoneId),
                        _deliveryDate: !state.recipient.deliveryDate
                            ? ''
                            : formatInTimeZoneDate(`${state.recipient.deliveryDate}T00:00:00`, state.recipient.branchIanaTimeZoneId),
                    }))
                    this.submitted = false
                    this.props.getRecipient(
                        function (result, _this) {
                            _this.getDataRecipient(result, _this)
                        },
                        this,
                        this.state.recipient.recipientId
                    )
                    if (this.state.forceUpdate === null) window.location.reload()
                } else if (result.data.success === false) {
                    if (this.state.forceUpdate === null) window.location.reload()
                    const errorList = []
                    result.data.errors.map(function (e) {
                        errorList.push(e.message)
                    })
                    this.setState({ error: true, errorMessage: errorList, loading: false })
                } else {
                    if (this.state.forceUpdate === null) window.location.reload()
                    const message = Object.keys(result.data.errors).map(function (e) {
                        return `there was an error saving ${e}`
                    })
                    this.setState({ error: true, errorMessage: message, loading: false })
                }
                this.props.updateResponse('')
            }
        }

        if (this.props.resendEmailResponse !== prevProps.resendEmailResponse) {
            if (this.props.resendEmailResponse) {
                if (this.props.resendEmailResponse.success) {
                    this.setState({ loading: false })
                }
            }
        }
    }

    getDataRecipient(data, _this) {
        if (!data.data.data.enrollment) {
            const newEnrollment = {}
            newEnrollment.Exists = false
            data.data.data.enrollment = newEnrollment
        } else {
            data.data.data.enrollment.Exists = true
        }

        const x = JSON.stringify(cloneDeep(data.data.data), function (key, value) {
            if (value === null) {
                return ''
            }
            return value
        })
        _this.setState({
            recipient: data.data.data,
            comment: data.data.data.comment,
            commentAuthor: data.data.data.commentAuthor,
            commentDate: formatEditDate(data.data.data.commentDate),
            baseState: x,
        })
        this.setState(state => ({
            _expirationDate: !state.recipient.expirationDate
                ? ''
                : formatInTimeZoneDate(state.recipient.expirationDate, state.recipient.branchIanaTimeZoneId),
            _deliveryDate: !state.recipient.deliveryDate
                ? ''
                : formatInTimeZoneDate(state.recipient.deliveryDate, state.recipient.branchIanaTimeZoneId),
        }))
    }

    // Calls API for updating club on form submit
    handleSubmit = event => {
        if (event) event.preventDefault()

        const updVal = this.state.recipient
        if (!this.state.forceUpdate) {
            updVal.expirationDate = document.getElementById('expirationDate').value
            updVal.deliveryDate = document.getElementById('deliveryDate').value
        }
        this.setState({ recipient: updVal }, () => {
            const validation = this.validator.validate(this.state.recipient)
            const enrollmentValidation = this.enrollmentValidator.validate(
                this.state.recipient.enrollment
            )
            this.setState({ validation, enrollmentValidation })
            this.submitted = true
            if (!this.state.forceUpdate && this.state.forceUpdate != null) {
                this.setState({ forceUpdate: null })
                this.props.updateRecipient(updVal)
            } else if (validation.isValid) {
                if (!updVal.enrollment.Exists)
                    this.props.updateRecipient(updVal)
                else if (validation.isValid && enrollmentValidation.isValid)
                    this.props.updateRecipient(updVal)
            } else this.setState({ loading: false })
        })
        this.setState({
            comment: updVal.comment,
            commentAuthor: updVal.commentAuthor,
        })
    }

    isInvalid(e) {
        const input = e.target
        if (input.value) {
            input.classList.remove('is-invalid')
        } else {
            input.classList.add('is-invalid')
        }
    }

    render() {
        const { loading, recipient, _deliveryDate, _expirationDate } = this.state
        const status = ['Enrolled', 'Refunded', 'Disputed']
        if (this.state.cancel) {
            return (
                <Redirect
                    to={{
                        pathname: `/secure/gifts`,
                    }}
                />
            )
        }

        if (this.state.redirectProduct) {
            return (
                <Redirect
                    to={{
                        pathname: `/secure/productHistoryEdit/${this.state.recipient.productHistoryId}`,
                        state: { from: 'giftEdit', id: recipient.recipientId },
                    }}
                />
            )
        }

        if (this.state.redirectSales) {
            return (
                <Redirect
                    to={{
                        pathname: `/secure/saleEdit/${this.state.recipient.saleId}`,
                        state: { from: 'giftEdit', id: recipient.recipientId },
                    }}
                />
            )
        }

        const validation = this.submitted
            ? this.validator.validate(this.state.recipient)
            : this.state.validation

        const enrollmentValidation =
            this.submitted && recipient.enrollment
                ? this.enrollmentValidator.validate(this.state.recipient.enrollment)
                : this.state.enrollmentValidation

        const renderAssociates =
            (recipient && recipient.enrollment && !isEmpty(recipient.enrollment.associates)) ||
            (recipient && recipient.associates && !isEmpty(recipient.associates))

        return (
            <Container>
                <div className="card">
                    <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >
                        <CardTitle component="Gift" readOnly={this.state.readOnly} />

                        <PopupError
                            open={this.state.error}
                            onClose={this.closeModal}
                            onClick={this.closeModal}
                            errorMessage={this.state.errorMessage}
                        />

                        <div className="card-body fs-12">
                            {recipient && (
                                <Form onSubmit={this.handleSubmit}>
                                    <RequiredFieldNotation />
                                    <div className="row">
                                        <div className="col-md-6 border-right">
                                            <Col className="gift-header">Recipient</Col>
                                            <Col>
                                                <Row form>
                                                    <Col style={{ flex: 10 }}>
                                                        <Label htmlFor='recipientFirstName' className="required-hint mt-4 mr-0">
                                                            <strong>First name</strong>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            maxLength="30"
                                                            readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                            id="recipientFirstName"
                                                            name="recipientFirstName"
                                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                            value={recipient.firstName}
                                                            onChange={e => {
                                                                this.isInvalid(e)
                                                                const x = recipient
                                                                x.firstName = e.target.value
                                                                this.setState({ recipient: x })
                                                            }}
                                                        />
                                                        <span className="help-block">{validation.firstName.message}</span>
                                                    </Col>
                                                    <Col style={{ flex: 2 }}>
                                                        <Label htmlFor='recipientMiddleInitial' className="mt-4">
                                                            <strong>MI</strong>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            maxLength="1"
                                                            readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                            id="recipientMiddleInitial"
                                                            name="recipientMiddleInitial"
                                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                            value={recipient.middleInitial}
                                                            onChange={e => {
                                                                const x = recipient
                                                                x.middleInitial = e.target.value
                                                                this.setState({ recipient: x })
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='recipientLastName' className="required-hint mt-4">
                                                    <strong>Last name</strong>
                                                </Label>
                                                <Input
                                                    type="input"
                                                    maxLength="30"
                                                    readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                    id="recipientLastName"
                                                    name="recipientLastName"
                                                    className={this.state.readOnly ? '' : 'input-editable'}
                                                    value={recipient.lastName}
                                                    onChange={e => {
                                                        this.isInvalid(e)
                                                        const x = recipient
                                                        x.lastName = e.target.value
                                                        this.setState({ recipient: x })
                                                    }}
                                                />
                                                <span className="help-block">{validation.lastName.message}</span>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='recipientEmail' className="required-hint mt-4">
                                                    <strong>Email address</strong>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    maxLength="256"
                                                    readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                    name="recipientEmail"
                                                    id='recipientEmail'
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                    value={recipient.email}
                                                    onChange={e => {
                                                        this.isInvalid(e)
                                                        const x = recipient
                                                        x.email = e.target.value
                                                        this.setState({ recipient: x })
                                                    }}
                                                />
                                                <InputFeedback feedbackText={feedback.email} id='recipientEmail' />
                                                <span className="help-block">{validation.email.message}</span>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='recipientMessage' className="mt-4">
                                                    <strong>Message</strong>
                                                </Label>
                                                <Input
                                                    type="textarea"
                                                    maxLength="500"
                                                    readOnly
                                                    id="recipientMessage"
                                                    name="recipientMessage"
                                                    value={recipient.message}
                                                />
                                            </Col>
                                            <Col>
                                                <hr />
                                            </Col>
                                            <Col className="gift-header">Enrollment</Col>
                                            <Col>
                                                <Label htmlFor='lastName' className="mt-4">
                                                    <strong>Last name</strong>
                                                </Label>
                                                {recipient.enrollment && (
                                                    <Input
                                                        type="text"
                                                        maxLength="30"
                                                        readOnly
                                                        id="lastName"
                                                        name="lastName"
                                                        className={
                                                            this.state.readOnly ||
                                                                !recipient.enrollment ||
                                                                !recipient.enrollment.Exists
                                                                ? 'form-control'
                                                                : 'input-editable'
                                                        }
                                                        value={recipient.enrollment ? recipient.enrollment.lastName : null}
                                                        onChange={e => {
                                                            this.isInvalid(e)
                                                            const x = recipient
                                                            x.enrollment.lastName = e.target.value
                                                            this.setState({ recipient: x })
                                                        }}
                                                    />
                                                )}
                                                <span className="help-block">{enrollmentValidation.lastName.message}</span>
                                            </Col>
                                            <Col>
                                                <Row form>
                                                    <Col style={{ flex: 10 }}>
                                                        <Label htmlFor='firstName' className="mt-4 mr-0">
                                                            <strong>First name</strong>
                                                        </Label>
                                                        {recipient.enrollment && (
                                                            <Input
                                                                type="text"
                                                                maxLength="30"
                                                                readOnly
                                                                id="firstName"
                                                                name="firstName"
                                                                className={
                                                                    this.state.readOnly ||
                                                                        !recipient.enrollment ||
                                                                        !recipient.enrollment.Exists
                                                                        ? 'form-control'
                                                                        : 'input-editable'
                                                                }
                                                                value={recipient.enrollment ? recipient.enrollment.firstName : null}
                                                                onChange={e => {
                                                                    this.isInvalid(e)
                                                                    const x = recipient
                                                                    x.enrollment.firstName = e.target.value
                                                                    this.setState({ recipient: x })
                                                                }}
                                                            />
                                                        )}
                                                        <span className="help-block">
                                                            {enrollmentValidation.firstName.message}
                                                        </span>
                                                    </Col>
                                                    <Col style={{ flex: 2 }}>
                                                        <Label htmlFor='middleInitial' className="mt-4">
                                                            <strong>MI</strong>
                                                        </Label>
                                                        {recipient.enrollment && (
                                                            <Input
                                                                type="text"
                                                                maxLength="1"
                                                                readOnly
                                                                id="middleInitial"
                                                                name="middleInitial"
                                                                className={
                                                                    this.state.readOnly ||
                                                                        !recipient.enrollment ||
                                                                        !recipient.enrollment.Exists
                                                                        ? 'form-control'
                                                                        : 'input-editable'
                                                                }
                                                                value={
                                                                    recipient.enrollment ? recipient.enrollment.middleInitial : null
                                                                }
                                                                onChange={e => {
                                                                    const x = recipient
                                                                    x.enrollment.middleInitial = e.target.value
                                                                    this.setState({ recipient: x })
                                                                }}
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='streetAddress' className="mt-4">
                                                    <strong>Street address</strong>
                                                </Label>
                                                {recipient.enrollment && (
                                                    <Input
                                                        type="text"
                                                        maxLength="150"
                                                        readOnly
                                                        id="streetAddress"
                                                        name="streetAddress"
                                                        className={
                                                            this.state.readOnly ||
                                                                !recipient.enrollment ||
                                                                !recipient.enrollment.Exists
                                                                ? 'form-control'
                                                                : 'input-editable'
                                                        }
                                                        value={recipient.enrollment ? recipient.enrollment.streetAddress : null}
                                                        onChange={e => {
                                                            this.isInvalid(e)
                                                            const x = recipient
                                                            x.enrollment.streetAddress = e.target.value
                                                            this.setState({ recipient: x })
                                                        }}
                                                    />
                                                )}
                                                <span className="help-block">
                                                    {enrollmentValidation.streetAddress.message}
                                                </span>
                                            </Col>
                                            <Col>
                                                <Row form>
                                                    <Col style={{ flex: 4 }}>
                                                        <Label htmlFor='city' className="mt-4">
                                                            <strong>City</strong>
                                                        </Label>
                                                        {recipient.enrollment && (
                                                            <Input
                                                                type="text"
                                                                maxLength="255"
                                                                readOnly
                                                                id="city"
                                                                name="city"
                                                                className={
                                                                    this.state.readOnly ||
                                                                        !recipient.enrollment ||
                                                                        !recipient.enrollment.Exists
                                                                        ? 'form-control'
                                                                        : 'input-editable'
                                                                }
                                                                value={recipient.enrollment ? recipient.enrollment.city : null}
                                                                onChange={e => {
                                                                    this.isInvalid(e)
                                                                    const x = recipient
                                                                    x.enrollment.city = e.target.value
                                                                    this.setState({ recipient: x })
                                                                }}
                                                            />
                                                        )}
                                                        <span className="help-block">{enrollmentValidation.city.message}</span>
                                                    </Col>
                                                    <Col style={{ flex: 2 }}>
                                                        <Label htmlFor='stateProvince' className="mt-4">
                                                            <strong>State</strong>
                                                        </Label>
                                                        <label
                                                            className={
                                                                this.state.readOnly ||
                                                                    !recipient.enrollment ||
                                                                    !recipient.enrollment.Exists
                                                                    ? 'select-disabled md-input'
                                                                    : 'select md-input'
                                                            }
                                                        >
                                                            {recipient.enrollment && (
                                                                <select
                                                                    id="stateProvince"
                                                                    disabled
                                                                    name="stateProvince"
                                                                    className={
                                                                        this.state.readOnly ||
                                                                            !recipient.enrollment ||
                                                                            !recipient.enrollment.Exists
                                                                            ? 'form-control'
                                                                            : 'input-editable form-control'
                                                                    }
                                                                    value={
                                                                        recipient.enrollment ? recipient.enrollment.stateProvince : null
                                                                    }
                                                                    onChange={e => {
                                                                        const x = this.state.recipient
                                                                        x.enrollment.stateProvince = e.target.value
                                                                        const y = this.state.recipient
                                                                        y.enrollment.stateProvinceId =
                                                                            e.target[e.target.selectedIndex].getAttribute('id')
                                                                        this.setState({ recipient: x, recipient: y })
                                                                    }}
                                                                >
                                                                    {' '}
                                                                    {!recipient.enrollment || !recipient.enrollment.Exists ? (
                                                                        <option />
                                                                    ) : (
                                                                        this.renderStateProvinces()
                                                                    )}
                                                                    { }
                                                                </select>
                                                            )}
                                                        </label>
                                                        <span className="help-block">
                                                            {enrollmentValidation.stateProvince.message}
                                                        </span>
                                                    </Col>
                                                    <Col style={{ flex: 3 }}>
                                                        <Label htmlFor='zipCode' className="mt-4">
                                                            <strong>ZIP code</strong>
                                                        </Label>
                                                        {recipient.enrollment && (
                                                            <Input
                                                                type="string"
                                                                maxLength="25"
                                                                readOnly
                                                                id="zipCode"
                                                                name="zipCode"
                                                                className={
                                                                    this.state.readOnly ||
                                                                        !recipient.enrollment ||
                                                                        !recipient.enrollment.Exists
                                                                        ? 'form-control'
                                                                        : 'input-editable'
                                                                }
                                                                value={
                                                                    recipient.enrollment ? recipient.enrollment.postalCode : null
                                                                }
                                                                onChange={e => {
                                                                    this.isInvalid(e)
                                                                    const x = recipient
                                                                    x.enrollment.postalCode = e.target.value
                                                                    this.setState({ recipient: x })
                                                                }}
                                                            />
                                                        )}
                                                        <span className="help-block">
                                                            {enrollmentValidation.postalCode.message}
                                                        </span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='enrollmentEmail' className="mt-4">
                                                    <strong>Email address</strong>
                                                </Label>
                                                {recipient.enrollment && (
                                                    <Input
                                                        type="text"
                                                        maxLength="256"
                                                        readOnly
                                                        name="enrollmentEmail"
                                                        id='enrollmentEmail'
                                                        className={
                                                            this.state.readOnly ||
                                                                !recipient.enrollment ||
                                                                !recipient.enrollment.Exists
                                                                ? 'form-control'
                                                                : 'input-editable'
                                                        }
                                                        value={recipient.enrollment ? recipient.enrollment.email : null}
                                                        onChange={e => {
                                                            this.isInvalid(e)
                                                            const x = recipient
                                                            x.enrollment.email = e.target.value
                                                            this.setState({ recipient: x })
                                                        }}
                                                    />
                                                )}
                                                <InputFeedback feedbackText={feedback.email} id='enrollmentEmail' />
                                                <span className="help-block">{enrollmentValidation.email.message}</span>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='telephone' className="mt-4">
                                                    <strong>Telephone</strong>
                                                </Label>
                                                {recipient.enrollment && (
                                                    <Input
                                                        type="text"
                                                        maxLength="20"
                                                        readOnly
                                                        name="telephone"
                                                        id='telephone'
                                                        className={
                                                            this.state.readOnly ||
                                                                !recipient.enrollment ||
                                                                !recipient.enrollment.Exists
                                                                ? 'form-control'
                                                                : 'input-editable'
                                                        }
                                                        value={recipient.enrollment ? recipient.enrollment.telephone : null}
                                                        onChange={e => {
                                                            this.isInvalid(e)
                                                            const x = recipient
                                                            x.enrollment.telephone = e.target.value
                                                            this.setState({ recipient: x })
                                                        }}
                                                    />
                                                )}
                                                <InputFeedback feedbackText={feedback.telephone} id='telephone' />
                                                <span className="help-block">{enrollmentValidation.telephone.message}</span>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='membershipNumber' className="mt-4">
                                                    <strong>Membership number</strong>
                                                </Label>
                                                {recipient.enrollment && (
                                                    <Input
                                                        type="text"
                                                        maxLength="20"
                                                        readOnly
                                                        id="membershipNumber"
                                                        name="membershipNumber"
                                                        className={
                                                            this.state.readOnly ||
                                                                !recipient.enrollment ||
                                                                !recipient.enrollment.Exists
                                                                ? 'form-control'
                                                                : 'input-editable'
                                                        }
                                                        value={recipient.enrollment ? recipient.enrollment.newMembership : null}
                                                        onChange={e => {
                                                            this.isInvalid(e)
                                                            const x = recipient
                                                            x.enrollment.newMembership = e.target.value
                                                            this.setState({ recipient: x })
                                                        }}
                                                    />
                                                )}
                                            </Col>
                                            <Col>
                                                <Label htmlFor='_giftReedemedDateTime' className="mt-4">
                                                    <strong>Redeemed/Enrolled time</strong>
                                                </Label>
                                                <Input
                                                    id="_giftReedemedDateTime"
                                                    readOnly
                                                    value={
                                                        recipient.enrollment?.Exists
                                                            ? formatInTimeZoneDateTime(recipient.enrollment.giftReedemedDateTime, recipient.branchIanaTimeZoneId)
                                                            : ''
                                                    }
                                                />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='_giftEnrollmentSentDateTime' className="mt-4">
                                                    <strong>Enrollment Sent/Resent to Club time</strong>
                                                </Label>
                                                <Input
                                                    id="_giftEnrollmentSentDateTime"
                                                    readOnly
                                                    value={
                                                        recipient.enrollment?.Exists && recipient.enrollment?.transmissionSentDate
                                                            ? formatInTimeZoneDateTime(recipient.enrollment.transmissionSentDate, recipient.branchIanaTimeZoneId)
                                                            : ''
                                                    }
                                                />
                                            </Col>
                                            {renderAssociates && (
                                                <>
                                                    <Col>
                                                        <hr />
                                                    </Col>
                                                    <Col className="gift-header">Associates</Col>
                                                    {((recipient.enrollment && !isEmpty(recipient.enrollment.associates))
                                                        ? recipient.enrollment.associates
                                                        : recipient.associates
                                                    ).map((associate, index) => {
                                                        const key = `${associate.recipientId}-${index}-key`
                                                        return (
                                                            <Col key={key}>
                                                                <Row form>
                                                                    <Col style={{ flex: 4 }}>
                                                                        <Label className="mt-4 mr-0">
                                                                            <strong>First name</strong>
                                                                        </Label>
                                                                        <Input
                                                                            type="text"
                                                                            maxLength="30"
                                                                            readOnly
                                                                            name="assosiateFirstName"
                                                                            className="form-control"
                                                                            value={associate.firstName}
                                                                        />
                                                                    </Col>
                                                                    <Col style={{ flex: 1 }}>
                                                                        <Label className="mt-4">
                                                                            <strong>MI</strong>
                                                                        </Label>
                                                                        <Input
                                                                            type="text"
                                                                            maxLength="1"
                                                                            readOnly
                                                                            name="assosiateMiddleInitial"
                                                                            className="form-control"
                                                                            value={associate.middleInitial}
                                                                        />
                                                                    </Col>
                                                                    <Col style={{ flex: 4 }}>
                                                                        <Label className="mt-4 mr-0">
                                                                            <strong>Last name</strong>
                                                                        </Label>
                                                                        <Input
                                                                            type="text"
                                                                            maxLength="30"
                                                                            readOnly
                                                                            name="assosiateLastName"
                                                                            className="form-control"
                                                                            value={associate.lastName}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        )
                                                    })}
                                                </>
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <Col className="d-md-none">
                                                <hr />
                                            </Col>
                                            <Col className="gift-header">Donor</Col>
                                            <Col>
                                                <div className="inline-label div-label-margin mt-4">
                                                    <strong>Donor</strong>
                                                </div>
                                                <div className="form-control readonly-div">
                                                    <Link to="#" onClick={this.onSaleLink}>
                                                        {recipient.saleName}
                                                    </Link>
                                                </div>
                                            </Col>
                                            <Col>
                                                <hr />
                                            </Col>
                                            <Col className="gift-header">Gift</Col>
                                            <Col>
                                                <div className="inline-label div-label-margin mt-4">
                                                    <strong>Product</strong>
                                                </div>
                                                <div className="form-control readonly-div">
                                                    <Link to="#" onClick={this.onProductLink}>
                                                        {recipient.productName}
                                                    </Link>
                                                </div>
                                            </Col>
                                            <Col>
                                                <Label htmlFor='_donorSelected' className="mt-4">
                                                    <strong>Donor-selected Location (Branch)</strong>
                                                </Label>
                                                <Input id="_donorSelected" readOnly value={recipient.cityName + ", " + recipient.stateCode + " (" + recipient.branchName + ")"} />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='_giftStatus' className="mt-4">
                                                    <strong>Gift status</strong>
                                                </Label>
                                                <Input id="_giftStatus" readOnly value={recipient.giftStatus} />
                                            </Col>
                                            {!this.state.readOnly && (
                                                <Row>
                                                    <div className="col">
                                                        <Col
                                                            className={`${validation.deliveryDate.isInvalid && this.submitted
                                                                ? 'has-error'
                                                                : ''
                                                                }`}
                                                        >
                                                            <Label htmlFor='deliveryDate' className="required-hint mt-4 big-date">
                                                                <strong>Gift delivery date</strong>
                                                            </Label>
                                                            <CustomDatePicker
                                                                id="deliveryDate"
                                                                className="big-date"
                                                                readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                                defValue={
                                                                    !recipient.deliveryDate
                                                                        ? ''
                                                                        : formatInTimeZoneDate(recipient.deliveryDate, recipient.branchIanaTimeZoneId).substring(0, 10)
                                                                }
                                                                onChange={day =>
                                                                    this.setState({
                                                                        recipient: {
                                                                            ...this.state.recipient,
                                                                            ...{ expirationDate: this.addDays(day, 60) },
                                                                        },
                                                                        deliveryDateChanged: true,
                                                                    })
                                                                }
                                                                label="Gift delivery date"
                                                            />
                                                            <span className="help-block-calendar">
                                                                {validation.deliveryDate.message}
                                                            </span>
                                                        </Col>
                                                    </div>
                                                </Row>
                                            )}
                                            {this.state.readOnly && (
                                                <Col>
                                                    <Label htmlFor='_deliveryDate' className="required-hint mt-4">
                                                        <strong>Gift delivery date</strong>
                                                    </Label>
                                                    <Input id="_deliveryDate" readOnly value={_deliveryDate} />
                                                </Col>
                                            )}
                                            <Col>
                                                <Label htmlFor='_deliveredDate' className="mt-4">
                                                    <strong>Email delivered time</strong>
                                                </Label>
                                                <Input
                                                    id="_deliveredDate"
                                                    readOnly
                                                    value={
                                                        recipient.deliveredDate ? formatInTimeZoneDateTime(recipient.deliveredDate, recipient.branchIanaTimeZoneId) : ''
                                                    }
                                                />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='_lastRedeliveredDate' className="mt-4">
                                                    <strong>Email last resent time</strong>
                                                </Label>
                                                <Input
                                                    id="_lastRedeliveredDate"
                                                    readOnly
                                                    value={
                                                        recipient.lastRedeliveredDate
                                                            ? formatInTimeZoneDateTime(recipient.lastRedeliveredDate, recipient.branchIanaTimeZoneId)
                                                            : ''
                                                    }
                                                />
                                            </Col>
                                            {!this.state.readOnly && (
                                                <Row>
                                                    <div className="col">
                                                        <Col>
                                                            <Label htmlFor='expirationDate' className="mt-4 big-date">
                                                                <strong>Expiration date</strong>
                                                            </Label>
                                                            <CustomDatePicker
                                                                id="expirationDate"
                                                                readOnly={this.state.readOnly || status.includes(recipient.giftStatus)}
                                                                defValue={
                                                                    !recipient.expirationDate
                                                                        ? ''
                                                                        : formatInTimeZoneDate(recipient.expirationDate, recipient.branchIanaTimeZoneId).substring(0, 10)
                                                                }
                                                                label="Expiration date"
                                                            />
                                                        </Col>
                                                    </div>
                                                </Row>
                                            )}
                                            {this.state.readOnly && (
                                                <Col>
                                                    <Label htmlFor='_expirationDate' className="mt-4">
                                                        <strong>Expiration date</strong>
                                                    </Label>
                                                    <Input id="_expirationDate" readOnly value={_expirationDate} />
                                                </Col>
                                            )}
                                            <Col>
                                                <Label htmlFor='_refundDate' className="mt-4">
                                                    <strong>Refund date</strong>
                                                </Label>
                                                <Input
                                                    id="_refundDate"
                                                    readOnly
                                                    value={
                                                        recipient.refundDate
                                                            ? formatInTimeZoneDateTime(recipient.refundDate, recipient.branchIanaTimeZoneId)
                                                            : ''
                                                    }
                                                />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='promoCode' className="mt-4">
                                                    <strong>Promo code</strong>
                                                </Label>
                                                <Input
                                                    id='promoCode'
                                                    readOnly
                                                    className="form-control"
                                                    value={`${recipient.promoCodeCode || ''}`}
                                                />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='salesTax' className="mt-4">
                                                    <strong>Sales Tax</strong>
                                                </Label>
                                                <Input
                                                    id='salesTax'
                                                    readOnly
                                                    className="form-control"
                                                    value={`$${recipient.salesTaxAmt ? recipient.salesTaxAmt.toFixed(2) : 0}`}
                                                />
                                            </Col>
                                            <Col>
                                                <Label htmlFor='totalCharge' className="mt-4">
                                                    <strong>Total Charge (including Sales Tax)</strong>
                                                </Label>
                                                <Input
                                                    id='totalCharge'
                                                    readOnly
                                                    className="form-control"
                                                    value={`$${recipient.totalCharge.toFixed(2)}`}
                                                />
                                            </Col>
                                            <Col>
                                                <MakeAComment
                                                    comment={this.state.comment}
                                                    commentAuthor={this.state.commentAuthor}
                                                    commentDate={this.state.commentDate}
                                                    onChangeHandler={this.onChangeComment.bind(this)}
                                                    isEdit={this.state.edit}
                                                    maxLength='500'
                                                />
                                            </Col>
                                        </div>
                                    </div>
                                    <Row>
                                        <div className="col-md-6">
                                            <Col className="text-left float-bottom d-flex flex-wrap justify-content-around flex-row">
                                                <Button
                                                    onClick={this.handleResendEmail.bind(this)}
                                                    className={
                                                        this.state.readOnly && this.state.recipient.giftStatus === 'Active'
                                                            ? 'mail-btn'
                                                            : 'd-none'
                                                    }
                                                >
                                                    RESEND EMAIL
                                                </Button>
                                                <Button
                                                    onClick={this.toggleModal}
                                                    disabled={recipient.enrollment?.Exists}
                                                    className={
                                                        this.state.readOnly && this.state.recipient.giftStatus !== 'Refunded'
                                                            ? 'edit-btn'
                                                            : 'd-none'
                                                    }
                                                >
                                                    REFUND
                                                </Button>
                                                <Button
                                                    onClick={this.showCharge}
                                                    className={this.state.readOnly ? 'mail-btn' : 'd-none'}
                                                >
                                                    VIEW CHARGE
                                                </Button>
                                            </Col>
                                        </div>
                                        <div className="col-md-6">
                                            <Col className="text-right float-bottom d-flex flex-wrap justify-content-around flex-row">
                                                {recipient.canResendEnrollment && (
                                                    <Button
                                                        onClick={this.handleResendEnrollment}
                                                        disabled={this.state.disableSendClub}
                                                        className={
                                                            this.state.readOnly &&
                                                                (!this.state.recipient.enrollment ||
                                                                    this.state.recipient.enrollment.Exists)
                                                                ? 'mail-btn'
                                                                : 'd-none'
                                                        }
                                                        style={{
                                                            paddingTop: 5,
                                                            lineHeight: 1.2,
                                                            fontSize: 13
                                                        }}                                                    >
                                                        RESEND ENROLLMENT
                                                    </Button>)}
                                                <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">
                                                    CANCEL
                                                </Button>
                                                <Button
                                                    onClick={this.handleEdit.bind(this)}
                                                    className={this.state.readOnly ? 'mail-btn' : 'd-none'}
                                                >
                                                    EDIT
                                                </Button>
                                                <Button
                                                    onClick={this.handleSubmit.bind(this)}
                                                    type="submit"
                                                    color="primary"
                                                    className={this.state.readOnly ? 'd-none' : 'mail-btn'}
                                                >
                                                    SAVE
                                                </Button>
                                            </Col>
                                        </div>
                                    </Row>
                                </Form>
                            )}
                            <Col>
                                <hr />
                            </Col>
                            {recipient && (
                                <Col>
                                    <Row>
                                        <div className="col-md-1">
                                            <div className="inline-label">
                                                <strong>ID</strong>
                                            </div>
                                            <p className="editFooterText">{recipient.recipientId}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="inline-label">
                                                <strong>Created by</strong>
                                            </div>
                                            <p className="font-weight-light">{recipient.createdBy}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="inline-label">
                                                <strong>Created date</strong>
                                            </div>
                                            <p className="font-weight-light">{formatInTimeZoneDateTime(recipient.createdDate, recipient.branchIanaTimeZoneId)}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="inline-label">
                                                <strong>Updated by</strong>
                                            </div>
                                            <p className="font-weight-light">{recipient.updatedBy}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="inline-label">
                                                <strong>Updated date</strong>
                                            </div>
                                            <p className="font-weight-light">{formatInTimeZoneDateTime(recipient.updatedDate, recipient.branchIanaTimeZoneId)}</p>
                                        </div>
                                    </Row>
                                </Col>
                            )}
                            {recipient && (
                                <Modal isOpen={this.state.toggle} toggle={this.toggleModal}>
                                    <ModalHeader toggle={this.toggleModal}>Verify Refund Amount</ModalHeader>
                                    <ModalBody style={{ textAlign: 'center' }}>
                                        <Form>
                                            <FormGroup className="row">
                                                <Input
                                                    type="hidden"
                                                    id="amount"
                                                    name="amount"
                                                    innerRef={input => (this.amount = input)}
                                                    defaultValue={recipient.totalCharge}
                                                />
                                                <span style={{ textAlign: 'center' }} className="col-sm-12">
                                                    Amount: $ {parseFloat(recipient.totalCharge).toFixed(2)}
                                                </span>
                                            </FormGroup>
                                            <FormGroup>
                                                <Button
                                                    style={{ marginRight: '10px' }}
                                                    onClick={this.handleRefund}
                                                    color="success"
                                                >
                                                    Refund
                                                </Button>
                                                <Button className="btn-color-cancel" onClick={this.toggleModal}>
                                                    Cancel
                                                </Button>
                                            </FormGroup>
                                        </Form>
                                    </ModalBody>
                                </Modal>
                            )}
                            {recipient && (
                                <Modal isOpen={this.state.toggleEnroll} toggle={this.toggleModalEnroll}>
                                    <ModalHeader toggle={this.toggleModalEnroll}>Sent / Resent Enrollment to club</ModalHeader>
                                    <ModalBody style={{ textAlign: 'center' }}>
                                        <FormGroup className="row d-flex flex-column align-items-center">
                                            <span style={{ textAlign: 'center' }} className="col-sm-12">
                                                The enrollment information submission to the club has started
                                            </span>
                                            <Button color="success" onClick={this.toggleModalEnroll}>
                                                OK
                                            </Button>
                                        </FormGroup>
                                    </ModalBody>
                                </Modal>
                            )}
                        </div>
                    </LoadingOverlay>
                </div>
            </Container>
        )
    }
}
export default connect(
    state => {
        return {
            recipient: state.data.recipient,
            updateResult: state.data.updateResult,
            responseRefund: state.data.responseRefund,
            stateProvinces: state.data.stateProvinces,
            resendEmailResponse: state.data.resendEmailRecipientResponse,
            sendRouterResponse: state.data.sendToRouterResponse,
        }
    },
    dispatch => ({
        getRecipient: (callback, context, id) => {
            dispatch(getRecipient(callback, context, id))
        },
        updateRecipient: (callback, context) => {
            dispatch(updateRecipient(callback, context))
        },
        updateResponse: response => {
            dispatch(updateResponse(response))
        },
        getStateProvinces: (callback, context) => {
            dispatch(getStateProvinces(callback, context))
        },
        currentNavigationConnect: response => {
            dispatch(updateRedirect(response))
        },
        resendEmailServiceConnect: (callback, context, id) => {
            dispatch(resendEmailService(callback, context, id))
        },
        updateResponseResendEmailConnect: response => {
            dispatch(updateResponseResendEmail(response))
        },
        updatesendRouterResponse: response => {
            dispatch(updateRouter(response))
        },
        RefundByGift: (clubId, stripeChargeId, amount) => {
            dispatch(RefundByGift(clubId, stripeChargeId, amount))
        },
        RefundChargeByGift: (clubId, recipientId) => {
            dispatch(RefundChargeByGift(clubId, recipientId))
        },
        updateRefund: response => {
            dispatch(updateRefund(response))
        },
        getSettings: (callback, context) => {
            dispatch(getSettings(callback, context))
        },
        sendToRouter: id => {
            dispatch(sendToRouter(id))
        },
    })
)(GiftEdit)
